
import Vue from 'vue'
import { Step } from '../store'
import { CheckoutPageModel } from '@ViewModels/CheckoutPageModel'

interface Breadcrumb {
   name: string
   value: Step
   visible: boolean
   canClick: boolean
}

export default Vue.extend({
   name: 'LogoComponent',
   computed: {
      step(): Step {
         return this.$store.state.step
      },
      viewedSteps(): Step[] {
         return this.$store.state.viewedSteps
      },
      showShipping(): boolean {
         return this.$store.getters.requiresDelivery
      },
      breadcrumbs(): Breadcrumb[] {
         const steps = [
            { name: 'Information', value: 'information' as Step, visible: true, canClick: false },
            { name: 'Order Type', value: 'order_type' as Step, visible: true, canClick: false },
            {
               name: 'Shipping',
               value: 'shipping' as Step,
               visible: this.showShipping,
               canClick: false,
            },
            { name: 'Payment', value: 'payment' as Step, visible: true, canClick: false },
         ]
         steps.forEach(step => (step.canClick = this.viewedSteps.includes(step.value)))
         return steps
      },
   },
   methods: {
      handleClick(breadcrumb: Breadcrumb) {
         if (breadcrumb.canClick) {
            this.$store.commit('setStep', breadcrumb.value)
         }
      },
   },
})
